<template>
  <div
    @click="$emit('handle-click')"
     :style="{
      'opacity':disabled ? '0.5':'1',
      'background':inlineEditable ? 'none' : tag.color?convertHexToRgb(tag.color):'transparent'}"
    :class="inlineEditable ? '' : spaceOutTags?'project-tag mr-5 mb-2':'project-tag mt-0'">
      <div class="ai-tag-icon-container" v-if="showAITagIcon">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 15 15" fill="none">
          <path d="M9.33335 2.46094C10.2308 2.46094 10.9584 1.7334 10.9584 0.835938H11.7084C11.7084 1.7334 12.4359 2.46094 13.3334 2.46094V3.21094C12.4359 3.21094 11.7084 3.93848 11.7084 4.83594H10.9584C10.9584 3.93848 10.2308 3.21094 9.33335 3.21094V2.46094ZM0.666687 6.83594C2.87583 6.83594 4.66669 5.04508 4.66669 2.83594H6.00002C6.00002 5.04508 7.79089 6.83594 10 6.83594V8.16927C7.79089 8.16927 6.00002 9.96014 6.00002 12.1693H4.66669C4.66669 9.96014 2.87583 8.16927 0.666687 8.16927V6.83594ZM3.25069 7.5026C4.1248 7.98767 4.84831 8.71114 5.33335 9.58527C5.8184 8.71114 6.54191 7.98767 7.41602 7.5026C6.54191 7.01754 5.8184 6.29407 5.33335 5.41994C4.84831 6.29407 4.1248 7.01754 3.25069 7.5026ZM11.5 8.83594C11.5 10.0325 10.53 11.0026 9.33335 11.0026V12.0026C10.53 12.0026 11.5 12.9727 11.5 14.1693H12.5C12.5 12.9727 13.4701 12.0026 14.6667 12.0026V11.0026C13.4701 11.0026 12.5 10.0325 12.5 8.83594H11.5Z" :fill="tag.color"/>
        </svg>
      </div>
      <template v-if="inlineEditable">
        <div class="inline-editable-tag-container"
        :style="{
              'border': tag.color ? `1px solid ${convertHexToRgb(tag.color)}` : '1px solid transparent',

          }"
        >
          <template v-if="showTagIcon">
            <i 
            :style="{
              'color':tag.color?tag.color:'black', 
              'font-size': fontSize
            }"
            class="ri-price-tag-3-line"></i>
          </template>
          <input 
            @focus="isInputFocused = true"
            @blur="saveContent($event,tag)"
            @keydown.enter.prevent="saveContent($event,tag)"
            :placeholder="tag.isNewTag ? 'Enter a tag name' : ''"
            :class="[ 'project-tag', 'inline-editable-tag',{'tag-name-error':tag.nameError}]" 
            :value="tag.isNewTag ? newTagName : tag.name" 
            :style="{
              '--input-color': tag.color ? convertHexToRgb(tag.color) : 'transparent',
              '--input-color-raw': tag.color ? getRawRgb(tag.color) : '0,0,0',
              'background': isInputFocused ? 'none' : tag.color ? convertHexToRgb(tag.color) : 'transparent',
              // 'border': tag.color ? `1px solid ${convertHexToRgb(tag.color)}` : '1px solid transparent',
              'color': tag.color ? tag.color : 'black', 
              'font-size': fontSize,
            }"
          >
        </div>
      </template>
      <template v-else>
        <abbr class="abr" :title="tag.name">
          <span class="tag-name" :style="{'color':tag.color?tag.color:'black', 'font-size': fontSize}">

            <template v-if="renderedIn == 'analysis-tag-view'"> {{ tag.name | trimTagLengthAnalysisTagView }} </template>
            <template v-else-if="renderedIn == 'analysis-question-view'"> {{ tag.name | trimTagLengthAnalysisQuestionView }} </template>
            <template v-else-if="renderedIn='project-tags-manager'"> {{ tag.name | trimTagLengthProjectTagsManager }} </template>
            <template v-else> {{ tag.name | trimLongLength }} </template> 
          </span> 
        </abbr>
        <button 
          :disabled="disabled"
          v-if="allowDelete"
          class="remove-tag-btn" 
          @click.stop="$emit('remove-tag')"
          >
          <i class="ri-close-line remove-btn-icon" 
          :style="{'background':convertHexToRgbDark(tag.color)}"
          ></i>
        </button>
      </template>

    </div>
</template>

<script>
import tinycolor from 'tinycolor2';


export default {
    data(){
      return{
        newTagName: this.tag.name ? this.tag.name : '', // State to store the name of the new tag
        isInputFocused: false  // State to keep track of the focus state of the input field
      }
    },
    props:{
        renderedIn:{},
        tag:{},
        spaceOutTags:{
            default:true
        },
        allowDelete:{
          default:false
        },
        disabled:{
          default:false
        },
        fontSize:{
          default:'12px'
        },
        showTagIcon:{
          default: false
        },
        hideAITagIcon:{
          default: false
        },
        inlineEditable:{
          default: false
        }
    },
    inject:[
      'projectStateData'
    ],
    methods:{
    trimTagLengthProjectTagsManagerHelper(val){
      let cutOff = 63
        if (val.length < cutOff) {
          return val;
        }
        return `${val.substring(0, cutOff-3)}...`;
    },
    convertHexToRgb(color){
      if(!color) return;
      const _color = tinycolor(color);
      _color.toHexString();
      let bgColorCSS=`rgba(${_color._r},${_color._g},${_color._b},0.1)`
      return bgColorCSS;
    },
    convertHexToRgbDimmed(color){
    const _color = tinycolor(color);
    _color.toHexString();
    let bgColorCSS=`rgba(${_color._r},${_color._g},${_color._b},0.15)`
    return bgColorCSS;
    },
    convertHexToRgbDark(color){
    const _color = tinycolor(color);
    _color.toHexString();
    let bgColorCSS=`rgba(${_color._r},${_color._g},${_color._b},0.3)`
    return bgColorCSS;
    },
    async saveContent($event,tag){
      this.isInputFocused = false;
      const updatedTagName = $event.target.value
      // console.log({updatedTagName},{tag})
      if(tag.isNewTag){
        // This is a new tag, don't do anything, return
        this.newTagName = updatedTagName
        return;
      }else{
        if(updatedTagName.trim()===tag.name.trim()) return;
        console.log('emitting save tag name',updatedTagName)
        this.$emit('save-tag-name',updatedTagName)
        $event.target.blur() 
      }

    },
    getRawRgb(color) {
      if(!color) return '0,0,0';
      const _color = tinycolor(color);
      return `${_color._r},${_color._g},${_color._b}`;
    },
  },
  computed:{
    showAITagIcon(){
      if (!this.hideAITagIcon && this.projectStateData && this.projectStateData.tagIdToTypeMapping 
              && this.projectStateData.tagIdToTypeMapping[this.tag.tagId]
                && this.projectStateData.tagIdToTypeMapping[this.tag.tagId] == 'ai_tag'
        )
      return true;
      else return false
    }
  },
  filters:{
    trimTagLengthAnalysisTagView(val) {
        let cutOff = 40
        if (val.length < cutOff) {
          return val;
        }
        return `${val.substring(0, cutOff-3)}...`;
    },
    trimTagLengthAnalysisQuestionView(val) {
        let cutOff = 43
        if (val.length < cutOff) {
          return val;
        }
        return `${val.substring(0, cutOff-3)}...`;
    },
    trimTagLengthProjectTagsManager(val) {
        let cutOff = 63
        if (val.length < cutOff) {
          return val;
        }
        return `${val.substring(0, cutOff-3)}...`;
    },
    trimLongLength(val) {
        let cutOff = 63
        if (val.length < cutOff) {
          return val;
        }
        return `${val.substring(0, cutOff-3)}...`;
    },
  }

}
</script>

<style scoped>
    .abr{
      display: inline-flex;
      align-items: center;
      text-decoration: none;

    }
    .project-tag{
      position: relative;
      display: inline-flex;
      flex-direction: row;
      align-items: center;
      padding: 2px 8px;
      gap: 4px;
      /* max-width: 80px; */
      height: 24px;
      /* Accent/Red/Light */
      border-radius: 8px;
      width:auto;
      cursor: default;
      white-space: nowrap; /* Prevent wrapping within the span */
      overflow: hidden;
      text-overflow: ellipsis;
      text-decoration: none;
    }

    .remove-tag-btn{
      display: none;
      position: absolute;
      right: 2px;
      background: #fff;
      height: 18px;
      width: 18px;
      border-radius: 20px;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      outline: none;
    }

    .tag::disabled{

    }

    .project-tag:hover .remove-tag-btn{
      display: flex;
    }

    .remove-btn-icon {
      display: flex;
      height: 18px;
      width: 18px;
      border-radius: 20px;
      align-items: center;
      justify-content: center;
      color: #666666;
      font-size: 16px;
      outline: none;
    }

    .tag-name{
      font-family: 'Inter';
      font-style: normal;
      font-weight: 600;
      /* font-size: 12px; */
      line-height: 150%;
      /* identical to box height, or 18px */

      text-transform: capitalize;
    }

    button:disabled{
      opacity: 0.5;
      cursor: not-allowed;
    }

    .inline-editable-tag-container{
      width: 100%;
      position: relative;
      border-radius: 8px;
    }

    .inline-editable-tag-container i{
      position: absolute;
      position: absolute;
      left: 8px;
      top: 2px;
    }

    .inline-editable-tag{
      cursor: pointer;
      width: 100%;
      padding-left: 7%;
      transition: background-color 0.2s ease;
    }

    .inline-editable-tag:focus {
      /* border: 1px solid var(--input-color); */
      /* background: #fff; */
    }

    .inline-editable-tag::placeholder {
      color: var(--input-color);
      opacity: 1; /* Firefox requires this to show custom placeholder colors */
    }

    .inline-editable-tag:hover {
      background-color: rgba(var(--input-color-raw), 0.05) !important;
    }

    .tag-name-error::placeholder{
      color: #C53030;
    }

</style>